import { AuthorAvatar } from '@components/ArtBoard/Threads/components/AuthorAvatar'
import type { EditorValue } from '@octopus-do/octopus-editor'
import type React from 'react'
import type { MouseEventHandler } from 'react'
import { createPortal } from 'react-dom'

import { useAuth } from '@/hooks/useAuth'
import { buildRecipient } from '@/utils'
import type { Offset } from '@/utils/offset'
import { NewCommentForm } from '../NewCommentForm'
import css from './styles.module.css'

interface Props {
  position: Offset | null
  onSubmit: (value: EditorValue, author: string) => void
}

const preventClosing: MouseEventHandler = (e) => {
  e.stopPropagation()
}

export const NewThreadForm: React.FC<Props> = ({ position, onSubmit }) => {
  const auth = useAuth()
  const author = buildRecipient(auth)

  if (!position) {
    return null
  }
  const left = `${position.x}px`
  const top = `${position.y}px`

  // Rendered outside the canvas: the position is in viewport coordinates
  // anyway, the form stays above the header and the footer, and a wheel
  // over the editor does not pan the canvas underneath.
  return createPortal(
    <div
      onClick={preventClosing}
      className={css.new_thread_form}
      style={{ left, top }}
    >
      <div className={css.bubble_form}>
        <div className={css.bubble}>
          <AuthorAvatar author={author} size="sm" />
        </div>

        <div className={css.editor}>
          <NewCommentForm autofocus onSubmit={onSubmit} />
        </div>
      </div>
    </div>,
    document.body
  )
}
